import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const getStateList = ({dispatch, token}) => {
    return ApiClient.get(`${API_URL}/workflow/get-states`, null, token, dispatch);
};

export const createApplicationType = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/workflow/create-applicationType`, values, token, dispatch);
};

export const updateApplicationType = ({values, dispatch, token, appId}) => {
    return ApiClient.put(`${API_URL}/workflow/update-applicationType?id=${appId}`, values, token, dispatch);
};

export const getApplicationType = ({dispatch, token, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/workflow/getAllApplications?page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, null, token, dispatch);
};


export const createDocumentType = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/workflow/create-documenType`, values, token, dispatch);
};

export const updateDocumentType = ({values, dispatch, token, docId}) => {
    return ApiClient.put(`${API_URL}/workflow/update-documenType?id=${docId}`, values, token, dispatch);
};

export const getDocumentTypeList = ({dispatch, token, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/workflow/getAllDocuments?page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, null, token, dispatch);
};

export const createPdfForm = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/workflow/create-pdfForm`, values, token, dispatch);
};

export const updatePdfForm = ({values, dispatch, token, formId}) => {
    return ApiClient.put(`${API_URL}/workflow/update-pdfForm?id=${formId}`, values, token, dispatch);
};

export const getPdfFormList = ({values, dispatch, token, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/workflow/getAllPdfForms?page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, values, token, dispatch);
};

export const createWorkflow = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/workflow/create-workflow`, values, token, dispatch);
};

export const updateWorkflow = ({values, dispatch, token, workflowId}) => {
    return ApiClient.put(`${API_URL}/workflow/update-workflow?id=${workflowId}`, values, token, dispatch);
};

export const getAllworkflow = ({values, dispatch, token, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/workflow/getAllWorkflows?page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, values, token, dispatch);
};

export const createSigner = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/workflow/create-signer`, values, token, dispatch);
};

export const getAllSigner = ({values, dispatch, token, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/workflow/getAllSigners?page=${page}&limit=${limit}&searchKey=${searchKey}&dataLimit=${dataLimit}`, values, token, dispatch);
};
